/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Studio_3_DescInputs */

const en_mk_studio_3_desc = /** @type {(inputs: Mk_Studio_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evidence bar per feature, exceptions, an Approve-phase button. Approvals are recorded in the client’s name.`)
};

const id_mk_studio_3_desc = /** @type {(inputs: Mk_Studio_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bar bukti per fitur, pengecualian, tombol Setujui fase. Persetujuan tercatat atas nama klien.`)
};

/**
* | output |
* | --- |
* | "Evidence bar per feature, exceptions, an Approve-phase button. Approvals are recorded in the client’s name." |
*
* @param {Mk_Studio_3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_studio_3_desc = /** @type {((inputs?: Mk_Studio_3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Studio_3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_studio_3_desc(inputs)
	return en_mk_studio_3_desc(inputs)
});